/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Simple_Door_Guided_P3Inputs */

const en_simple_door_guided_p3 = /** @type {(inputs: Simple_Door_Guided_P3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`One hour building together — ${i?.price}`)
};

const id_simple_door_guided_p3 = /** @type {(inputs: Simple_Door_Guided_P3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bangun bareng 1 jam — ${i?.price}`)
};

/**
* | output |
* | --- |
* | "One hour building together — {price}" |
*
* @param {Simple_Door_Guided_P3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_guided_p3 = /** @type {((inputs: Simple_Door_Guided_P3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Guided_P3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_guided_p3(inputs)
	return en_simple_door_guided_p3(inputs)
});